var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.937,
    height: 73.937
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2003",
    d: "M0 0h73.937v73.937H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Cib-tiktok_(CoreUI_Icons_v1.0.0)",
    d: "M39.134 10.709c2.845-.044 5.673-.018 8.5-.044a13.533 13.533 0 003.8 9.065 15.342 15.342 0 009.21 3.887v8.748a23.08 23.08 0 01-9.126-2.1 26.4 26.4 0 01-3.521-2.021c-.015 6.349.026 12.689-.041 19.012a16.54 16.54 0 01-2.938 8.563 16.176 16.176 0 01-12.842 6.966 15.81 15.81 0 01-8.86-2.231 16.372 16.372 0 01-7.926-12.409 36.392 36.392 0 01-.026-3.233 16.372 16.372 0 0118.97-14.523c.044 3.218-.085 6.434-.085 9.652a7.475 7.475 0 00-9.523 4.608 8.636 8.636 0 00-.295 3.5 7.416 7.416 0 0013.622 2.743 5.124 5.124 0 00.891-2.309c.213-3.887.129-7.757.155-11.643.018-8.759-.026-17.493.041-26.225z"
  })));
}
export default SvgSocialTiktok;